const addAllToCart = /* GraphQL */ `
  mutation addAllToCart($request: [CartItemRequest]!) {
    addAllToCart(request: $request) {
      id
      count
      items {
        product {
          id
          name
          sku
          attributes {
            code
            value
          }
          variants {
            type
            name
            price
          }
          media {
            type
            url
          }
        }
        price
        quantity
        format
      }
      totals {
        subtotal
      }
      relatedProducts {
        id
        sku
      }
    }
  }
`;

export default addAllToCart;
